const url_domain = window.location.host
let config_url = ''

if (url_domain == 'localhost:8080') {
  // config_url = 'http://127.0.0.1:3333/api/1.0'

  config_url = 'https://apitest.chamirides.com/api/1.0'
}  else if (url_domain == 'apptest.chamirides.com') {
 config_url = 'https://apitest.chamirides.com/api/1.0'
 }
 else if (url_domain == 'app.chamirides.com') {
  config_url = 'https://api.chamirides.com/api/1.0'
  }

console.log('Backend Conected: ' + config_url)
export const apiPath = config_url
